import type { IBarLabel } from '../IRenderer';

/**
 * BarLabel — shared helper for rendering numeric "current/max" labels
 * inline on top of HP / MP / energy bars.
 *
 * Used by MobRenderer + PlayerRenderer so both renderers stay in
 * lockstep on font, color, and depth.
 *
 * Phase H10 Arc λ.10 (2026-05-10): PhaserBarLabel fallback removed.
 * PixiFactoriesRegistry wires the Pixi impl at boot.
 */

type PixiFactory = (x: number, y: number) => IBarLabel;

let pixiFactory: PixiFactory | null = null;

export function registerPixiBarLabelFactory(fn: PixiFactory): void {
  pixiFactory = fn;
}

export function formatBarLabel(current: number, max: number): string {
  return `${Math.round(current)}/${Math.round(max)}`;
}

export function createBarLabel(
  _scene: unknown,
  x: number,
  y: number,
): IBarLabel {
  if (!pixiFactory) {
    throw new Error('[createBarLabel] Pixi factory not registered. Call registerAllPixiFactories() at boot.');
  }
  return pixiFactory(x, y);
}
